import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ItNotificationService, NotificationPosition } from 'design-angular-kit';
import { Router } from '@angular/router';

export const errorInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn
): Observable<HttpEvent<any>> => {
  const notificationService = inject(ItNotificationService);
  const router = inject(Router);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      const status = error.status;

      if (status >= 500) {
        notificationService.error(
          'Errore del server',
          'Si è verificato un errore interno. Riprova più tardi.',
          true,
          5000,
          NotificationPosition.Top
        );
      } else if (status === 401 || status === 403) {
        notificationService.warning(
          'Accesso negato',
          'Non sei autorizzato a eseguire questa operazione.',
          true,
          4000,
          NotificationPosition.Top
        );
        router.navigate(['/login']);
      } else if (status === 404) {
        notificationService.info(
          'Risorsa non trovata',
          'La risorsa richiesta non è disponibile.',
          true,
          4000,
          NotificationPosition.Top
        );
      } else {
        notificationService.warning(
          'Errore',
          error?.error?.message || 'Si è verificato un errore imprevisto.',
          true,
          4000,
          NotificationPosition.Top
        );
      }

      return throwError(() => error);
    })
  );
};
